module.exports = __webpack_public_path__ + "static/media/0121_IMG_TG.39ed18b1.webp";